
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"#5EA9FF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8.67","cy":"8","r":"8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.759 11.466a.089.089 0 11-.178 0 .089.089 0 01.178 0z"}}),_c('path',{attrs:{"d":"M8.759 11.466a.089.089 0 11-.178 0 .089.089 0 01.178 0","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.67 8.632l1.18-.655c.588-.327.953-.948.953-1.621a2.041 2.041 0 00-2.15-1.911 2.084 2.084 0 00-2.116 1.61"}}),_c('path',{attrs:{"d":"M8.67 8.632l1.18-.655c.588-.327.953-.948.953-1.621a2.041 2.041 0 00-2.15-1.911 2.084 2.084 0 00-2.116 1.61","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    